import React from 'react';
import { DashboardData } from '../../types';
import StatsGrid from './StatsGrid';
import Charts from './Charts';
import RecentActivity from './RecentActivity';

interface OverviewProps {
  data: DashboardData;
  onRefresh: () => void;
}

const Overview: React.FC<OverviewProps> = ({ data, onRefresh }) => {
  return (
    <div id="overview">
      <StatsGrid stats={data.stats} />
      <Charts signups={data.signups} stats={data.stats} />
      <RecentActivity stats={data.stats} />
    </div>
  );
};

export default Overview;
